import { Group, Stack, Text } from '@mantine/core';
import { useVideo } from '@/api/queries';
import type { AdminVideo } from '@/api/types';
import { VideoStatusBadge } from '@/components/StatusBadge';
import { UploadProgress } from '@/features/uploads/UploadProgress';
import { useUploadFor } from '@/features/uploads/context';
import { formatDuration } from '@/lib/format';

/** Compact video status that polls until ready and shows tus progress for uploads in flight. */
export function VideoSummary({ video }: { video: AdminVideo }) {
  const live = useVideo(video.status === 'ready' || video.status === 'errored' ? null : video.id);
  const v = live.data ?? video;
  const upload = useUploadFor(video.id);
  return (
    <Stack gap={4}>
      <Group gap="xs" wrap="nowrap">
        <VideoStatusBadge status={v.status} />
        <Text size="sm" truncate>
          {v.title}
        </Text>
        <Text size="xs" c="dimmed">
          {formatDuration(v.duration_s)}
        </Text>
      </Group>
      {upload && upload.phase !== 'uploaded' && <UploadProgress upload={upload} />}
      {v.status === 'errored' && (
        <Text size="xs" c="coral.8">
          Encoding failed at Bunny. Upload the file again.
        </Text>
      )}
    </Stack>
  );
}
